import { Injectable } from '@angular/core';
import { ToastOptions } from '../../models/ToastOptions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastsConfig } from '../../config/toasts.config';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

@Injectable({
  providedIn: 'root'
})
/**
 * Exposes functions to show toasts
 */
export class ToastService {

  /**
   * @param _snackBar The MatSnackBar provided by angular
   */
  constructor(
    private _snackBar: MatSnackBar
  ) { }

  /**
   * Show a toast
   * @param message The message that the toast shall bear
   * @param type The type of the toast
   * @param duration The duration of the toast
   */
  public show(message: string, type: ToastType = 'info', duration: number = 3000): void {
    const panelClass = `toast-${type}`;
    
    this._snackBar.open(message, 'Close', {
      duration,
      panelClass: [panelClass],
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }
}
